module.exports = __webpack_public_path__ + "static/desiree.768db17a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/desiree.png
// module id = 570
// module chunks = 263791100135453